import { Injectable } from '@angular/core'
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { BehaviorSubject, Observable } from 'rxjs'

import { map } from 'rxjs/operators'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { NinthWaveProps } from '../additional/NinthWaveProps'
import { ACCOUNT_AUTH_GROUP } from 'src/app/modules/account/account-api'


export interface AuthThirdPartyBody {
    consentType: string
    returnConsents: boolean
    returniCWPreferredFIList: boolean
    thirdPartyId: string
}

export interface AuthThirdPartyResp {
  status: string
  message?: any
  resultMap: {
    Consents: {
      id: number;
      description: string;
      type: string;
      shortCode: string;
      version: number;
      text: string;
      active: boolean;
      links: string;
    }[];
    partnerAccessToken: string;
    partnerTknValidUpto: string;
  }
}


@Injectable({
  providedIn: 'root',
})
export class NinthWaveAuthThirdPartyService {


  authCreds: AuthThirdPartyBody
  savedAuthResponse: any

  constructor(
    private http: HttpClient,
    private modalStateService: ModalStateService,
  ) {
  }

  public saveNinthWaveProps(res: NinthWaveProps): NinthWaveProps {
    this.modalStateService.pushToLocalStorageProps(res)
    return res
  }


  // duck typing
  public getNinthWaveProps = (): NinthWaveProps =>
    this.modalStateService.getFromLocalStorageClass(new NinthWaveProps())


  public refreshAuth(): Observable<AuthThirdPartyResp> {
    return this.postAuth(this.authCreds)
    .pipe(map(res => {
      const props = this.saveNinthWaveProps(new NinthWaveProps(res.resultMap.partnerAccessToken))
      return res
    }))
  }


  public postAuth(
    body: AuthThirdPartyBody,
  ): Observable<AuthThirdPartyResp> {
    this.authCreds = body
    return this.requestPostAuth(body)
    .pipe(map(res => {
      this.savedAuthResponse = res
      this.saveNinthWaveProps(new NinthWaveProps(res.resultMap.partnerAccessToken))
      return this.savedAuthResponse
    }))
  }



  private requestPostAuth(
    body: AuthThirdPartyBody,
  ): Observable<AuthThirdPartyResp> {
    return this.http.post(ACCOUNT_AUTH_GROUP.AUTH_THIRD_PARTY, body) as any
  }

}

